import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { getSSOAcessToken, removeAuthToken } from '../../../utils/localStorage';

// LOGIN EMAIL & PASSWORD
export const ACTION_REQUEST_LOGIN = 'ACTION_REQUEST_LOGIN';
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILURE = 'REQUEST_LOGIN_FAILURE';

// FORGOT PASSWORD
export const REQUEST_FORGOT_PASSWORD_ACTION = 'REQUEST_FORGOT_PASSWORD_ACTION';
export const REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';
export const REQUEST_FORGOT_PASSWORD_SUCCESS = 'REQUEST_FORGOT_PASSWORD_SUCCESS';
export const REQUEST_FORGOT_PASSWORD_FAILURE = 'REQUEST_FORGOT_PASSWORD_FAILURE';

// LOGIN SOCIAL
export const ACTION_REQUEST_LOGIN_SOCIAL = 'ACTION_REQUEST_LOGIN_SOCIAL';
export const REQUEST_LOGIN_SOCIAL_SUCCESS = 'REQUEST_LOGIN_SOCIAL_SUCCESS';

// UNLINK SOCIAL ACCOUNT
export const REQUEST_UNLINK_SOCIAL_ACTION = 'REQUEST_UNLINK_SOCIAL_ACTION';
export const REQUEST_UNLINK_SOCIAL = 'REQUEST_UNLINK_SOCIAL';
export const REQUEST_UNLINK_SOCIAL_SUCCESS = 'REQUEST_UNLINK_SOCIAL_SUCCESS';
export const REQUEST_UNLINK_SOCIAL_FAILURE = 'REQUEST_UNLINK_SOCIAL_FAILURE';

// LOGIN TOKEN
export const REQUEST_LOGIN_TOKEN = 'REQUEST_LOGIN_TOKEN';
export const REQUEST_LOGIN_TOKEN_SUCCESSED = 'REQUEST_LOGIN_TOKEN_SUCCESSED';
export const REQUEST_LOGIN_TOKEN_FAILURED = 'REQUEST_LOGIN_TOKEN_FAILURED';

export const FETCH_USER_SAGA = 'FETCH_USER_SAGA';
export const FETCH_USER_ALLOW_REDIRECT = 'FETCH_USER_ALLOW_REDIRECT';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURED = 'FETCH_USER_FAILURED';

export const LOGOUT_ACTION = 'LOGOUT_ACTION';
export const LOGOUT_SAGA = 'LOGOUT_SAGA';

export const UPDATE_USER_SHOP = 'UPDATE_USER_SHOP';

// SIGNUP
export const ACTION_REQUEST_SIGNUP = 'ACTION_REQUEST_SIGNUP';
export const REQUEST_SIGNUP = 'REQUEST_SIGNUP';
export const REQUEST_SIGNUP_SUCCESS = 'REQUEST_SIGNUP_SUCCESS';
export const REQUEST_SIGNUP_FAILURE = 'REQUEST_SIGNUP_FAILURE';

// VERIFY FORGOT PASSWORD OTP
export const REQUEST_VERIFY_FORGOT_PASSWORD_ACTION = 'REQUEST_VERIFY_FORGOT_PASSWORD_ACTION';
export const REQUEST_VERIFY_FORGOT_PASSWORD = 'REQUEST_VERIFY_FORGOT_PASSWORD';
export const REQUEST_VERIFY_FORGOT_PASSWORD_SUCCESS = 'REQUEST_VERIFY_FORGOT_PASSWORD_SUCCESS';
export const REQUEST_VERIFY_FORGOT_PASSWORD_FAILURE = 'REQUEST_VERIFY_FORGOT_PASSWORD_FAILURE';

const defaultState = {
  // signup
  signupError: {},
  isSignupRequesting: false,
  isSignupFailure: false,
  isSignupSuccess: false,

  // login
  loginError: {},

  // login token
  isAllowRedirect: false,
  isAuthFinshed: false,
  isAuthRequesting: false,
  isAuthFailured: false,
  isAuthSuccessed: false,
  isRemovedShop: false,
  token: '',
  error: {},
  user: {},

  userConfig: {},
  userShop: {},
  updatingUserConfig: false,
  failedUpdatingUserConfig: false,

  // forgot token
  forgotPasswordError: {},
  isForgotPasswordRequesting: false,
  isForgotPasswordFailured: false,
  isForgotPasswordSuccessed: false,
  isForgotPasswordFinished: false,

  // UNLINK SOCIAL ACCOUNT
  unlinkSocial: {},
  unlinkSocialError: {},
  isUnlinkSocialRequesting: false,
  isUnlinkSocialFailure: false,
  isUnlinkSocialSuccess: false,

  // VERIFY OTP
  isVerifyOTPRequesting: false,
  isVerifyOTPSuccess: false,
  verifyOTPError: {},
};

const reducer = createReducer(defaultState, {
  // SIGNUP
  [ACTION_REQUEST_SIGNUP]: (state) => ({
    ...state,
    signupError: {},
  }),
  [REQUEST_SIGNUP]: (state) => ({
    ...state,
    signupError: {},
    isSignupRequesting: true,
  }),
  [REQUEST_SIGNUP_SUCCESS]: (state) => {
    return {
      ...state,
      signupError: {},
      isSignupFailure: false,
      isSignupSuccess: true,
      isSignupRequesting: false,
    };
  },
  [REQUEST_SIGNUP_FAILURE]: (state, action) => {
    return {
      ...state,
      signupError: action.payload,
      isSignupFailure: true,
      isSignupRequesting: false,
      isSignupSuccess: false,
    };
  },

  // LOGIN
  [ACTION_REQUEST_LOGIN]: (state) => ({
    ...state,
    loginError: {},
  }),
  [ACTION_REQUEST_LOGIN_SOCIAL]: (state) => ({
    ...state,
    loginError: {},
  }),
  [REQUEST_LOGIN]: (state) => ({
    ...state,
    loginError: {},
    isAuthRequesting: true,
  }),
  [REQUEST_LOGIN_SUCCESS]: (state, action) => {
    return {
      ...state,
      user: action?.payload?.data?.user || {},
      isAuthFinshed: true,
      isAuthFailured: false,
      isAuthSuccessed: action?.payload?.data?.user?.emailVerified || false,
      isAuthRequesting: false,
      loginError: {},
    };
  },
  [REQUEST_LOGIN_SOCIAL_SUCCESS]: (state, action) => {
    return {
      ...state,
      user: action?.payload?.data?.user || {},
      isAuthFinshed: true,
      isAuthFailured: false,
      isAuthSuccessed: true,
      isAuthRequesting: false,
      loginError: {},
    };
  },

  [REQUEST_LOGIN_FAILURE]: (state, action) => {
    return {
      ...state,
      loginError: action.payload,
      isAuthFinshed: true,
      isAuthFailured: true,
      isAuthRequesting: false,
      isAuthSuccessed: false,
    };
  },

  // LOGIN TOKEN
  [REQUEST_LOGIN_TOKEN]: (state) => ({
    ...state,
    isAuthRequesting: true,
    isAuthFinshed: false,
    isAuthFailured: false,
    isAuthSuccessed: false,
  }),
  [REQUEST_LOGIN_TOKEN_SUCCESSED]: (state, action) => {
    return {
      ...state,
      ...action.payload,
      isAuthFinshed: true,
      isAuthFailured: false,
      isAuthSuccessed: true,
      isAuthRequesting: false,
    };
  },
  [REQUEST_LOGIN_TOKEN_FAILURED]: (state, action) => {
    return {
      ...state,
      error: action.payload,
      isAuthFinshed: true,
      isAuthFailured: true,
      isAuthRequesting: false,
      isAuthSuccessed: false,
    };
  },
  [LOGOUT_ACTION]: (state) => {
    return {
      ...state,
      user: {},
      isAuthFailured: false,
      isAuthSuccessed: false,
      isAuthRequesting: false,
    };
  },

  [FETCH_USER_ALLOW_REDIRECT]: (state, action) => {
    return {
      ...state,
      isAllowRedirect: action.payload,
    };
  },

  [FETCH_USER_SUCCESS]: (state, action) => {
    const user = action.payload.data;
    const userConfig = action.payload.data.user_config;
    const userShop = action.payload.data.user_shop;
    return {
      ...state,
      user,
      userConfig,
      userShop,
      error: {},
      isAuthFinshed: true,
      isAuthFailured: false,
      isAuthSuccessed: true,
      isAuthRequesting: false,
    };
  },
  [FETCH_USER_FAILURED]: (state, action) => {
    return {
      ...state,
      error: action.payload,
      isAuthFinshed: true,
      isAuthFailured: true,
      isAuthRequesting: false,
      isAuthSuccessed: false,
    };
  },

  // FORGOT PASSWORD
  [REQUEST_FORGOT_PASSWORD]: (state) => ({
    ...state,
    forgotPasswordError: {},
  }),
  [REQUEST_FORGOT_PASSWORD_ACTION]: (state) => ({
    ...state,
    forgotPasswordError: {},
    isForgotPasswordRequesting: true,
    isForgotPasswordSuccessed: false,
    isForgotPasswordFailured: false,
  }),
  [REQUEST_FORGOT_PASSWORD_SUCCESS]: (state, action) => {
    return {
      ...state,
      user: action?.payload?.data?.user || {},
      isForgotPasswordFinshed: true,
      isForgotPasswordFailured: false,
      isForgotPasswordSuccessed: true,
      isForgotPasswordRequesting: false,
    };
  },
  [REQUEST_FORGOT_PASSWORD_FAILURE]: (state, action) => {
    return {
      ...state,
      forgotPasswordError: action.payload,
      isForgotPasswordFinshed: true,
      isForgotPasswordFailured: true,
      isForgotPasswordRequesting: false,
      isForgotPasswordSuccessed: false,
    };
  },
  // UNLINK SOCIAL ACCOUNT
  [REQUEST_UNLINK_SOCIAL]: (state, action) => ({
    ...state,
    unlinkSocialError: action.payload,
  }),
  [REQUEST_UNLINK_SOCIAL_ACTION]: (state) => ({
    ...state,
    unlinkSocialError: {},
    isUnlinkSocialRequesting: true,
  }),
  [REQUEST_UNLINK_SOCIAL_SUCCESS]: (state, action) => ({
    ...state,
    unlinkSocial: action.payload,
    isUnlinkSocialRequesting: false,
    isUnlinkSocialFailure: false,
    isUnlinkSocialSuccess: true,
  }),
  [REQUEST_UNLINK_SOCIAL_FAILURE]: (state, action) => ({
    ...state,
    unlinkSocialError: action.payload,
    isUnlinkSocialRequesting: false,
    isUnlinkSocialFailure: true,
    isUnlinkSocialSuccess: false,
  }),

  // VERIFY OTP
  [REQUEST_VERIFY_FORGOT_PASSWORD_ACTION]: (state) => ({
    ...state,
    isVerifyOTPRequesting: true,
    isVerifyOTPSuccess: false,
    verifyOTPError: {},
  }),
  [REQUEST_VERIFY_FORGOT_PASSWORD_SUCCESS]: (state) => ({
    ...state,
    isVerifyOTPRequesting: false,
    isVerifyOTPSuccess: true,
    verifyOTPError: {},
  }),
  [REQUEST_VERIFY_FORGOT_PASSWORD_FAILURE]: (state, action) => ({
    ...state,
    isVerifyOTPRequesting: false,
    isVerifyOTPSuccess: false,
    verifyOTPError: action.payload,
  }),
});

export default reducer;
export const namespace = 'auth';

export const loginAction = (credentials) => ({
  type: ACTION_REQUEST_LOGIN,
  payload: credentials,
});

export const loginSocialAction = (payloads) => ({
  type: ACTION_REQUEST_LOGIN_SOCIAL,
  payload: payloads,
});

export const signupAction = (credentials) => ({
  type: ACTION_REQUEST_SIGNUP,
  payload: credentials,
});
export const loginSucceed = (payload) => ({
  type: REQUEST_LOGIN_SUCCESS,
  payload,
});

export const loginByTokenAction = () => ({
  type: REQUEST_LOGIN_TOKEN,
});

export const logout = () => async (_dispatch, _getState) => {
  removeAuthToken();
};

export const unlinkSocialAction = (payload) => ({
  type: REQUEST_UNLINK_SOCIAL_ACTION,
  payload,
});

export const verifyForgotPasswordOTPAction = (credentials) => ({
  type: REQUEST_VERIFY_FORGOT_PASSWORD_ACTION,
  payload: credentials,
});

export const fetchUserInfo =
  (token = '', isAllowRedirect = true) =>
    async (dispatch, getState) => {
      dispatch({
        type: FETCH_USER_ALLOW_REDIRECT,
        payload: isAllowRedirect,
      });

      token = token ? token : getSSOAcessToken();
      return await callAPI({
        method: 'get',
        apiPath: '/auth/me',
        actionTypes: [FETCH_USER, FETCH_USER_SUCCESS, FETCH_USER_FAILURED],
        variables: {
          token,
        },
        headers: {
          ...(token && {
            Authorization: `Bearer ${token}`,
          }),
        },
        dispatch,
        getState,
      });
    };

export const forgotPasswordAction = (credentials) => ({
  type: REQUEST_FORGOT_PASSWORD_ACTION,
  payload: credentials,
});

export const forgotPasswordSucceed = (payload) => ({
  type: REQUEST_FORGOT_PASSWORD_SUCCESS,
  payload,
});

export const selectUser = (state) => state[namespace].user;
export const selectUserId = (state) => state[namespace].user.id;

export const loginAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/login',
    actionTypes: [REQUEST_LOGIN, REQUEST_LOGIN_SUCCESS, REQUEST_LOGIN_FAILURE],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};

export const loginSocialAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/login-social',
    actionTypes: [REQUEST_LOGIN, REQUEST_LOGIN_SOCIAL_SUCCESS, REQUEST_LOGIN_FAILURE],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};

export const unlinkSocialAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/unlink-social',
    actionTypes: [
      REQUEST_UNLINK_SOCIAL,
      REQUEST_UNLINK_SOCIAL_SUCCESS,
      REQUEST_UNLINK_SOCIAL_FAILURE,
    ],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};

export const signupAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/register',
    actionTypes: [REQUEST_SIGNUP, REQUEST_SIGNUP_SUCCESS, REQUEST_SIGNUP_FAILURE],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};

export const forgotPasswordAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/forgot-password',
    actionTypes: [
      REQUEST_FORGOT_PASSWORD,
      REQUEST_FORGOT_PASSWORD_SUCCESS,
      REQUEST_FORGOT_PASSWORD_FAILURE,
    ],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};

export const verifyForgotPasswordOTPAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/auth/forgot-password/verify-otp',
    actionTypes: [
      REQUEST_VERIFY_FORGOT_PASSWORD,
      REQUEST_VERIFY_FORGOT_PASSWORD_SUCCESS,
      REQUEST_VERIFY_FORGOT_PASSWORD_FAILURE,
    ],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};